<template>
  <div class="jitsi-box" :style="{top:switched ? '60px':'0', width:switched ? '13vw' : '100vw', zIndex:switched? '2':'1000', padding:switched ? '60px 0 20px 0' : '0'}">
    <!-- <VueDragResize class="jitsi-meeting-chatbox" drag-handle=".jitsi-meeting-chatbox-drag" 
      :parentLimitation="true" 
      :minh="200"
      :x="chatbox_x"
      :y="chatbox_y"
      :width="chatbox_width"
      :height="chatbox_height"
      @resizing="chatboxResizing"
      v-if="showChat">
      <div class="jitsi-meeting-chatbox-drag"></div>
      <Sidebox ref="sidebox" :channel="roomID" v-if="roomID" />
    </VueDragResize> -->

    <div class="jitsi-mode-switch-btn" @click.prevent="switchMode">
      <ion-icon :name="switched?'arrow-back':'arrow-forward'" style="font-size:1.3rem;cursor:pointer"></ion-icon>
    </div>
    <div id="jaas-container"></div>
    <div class="jitsi-sidebox-container" v-if="!switched">
      <i class="fas fa-comment jitsi-sidebox-container-icon" @click.prevent="showChat = !showChat" v-if="!showChat"></i>
      <i class="fas fa-comment-slash jitsi-sidebox-container-icon" @click.prevent="showChat = !showChat" v-if="showChat"></i>
      <Sidebox ref="sidebox" :channel="roomID" :refHeight="sideboxHeight" v-if="roomID && showChat" />
    </div>
  </div >
</template>

<script>
import api from '@/services/api.js';
import Sidebox from '@/components/chat_qa_box/Sidebox.vue';
import VueDragResize from 'vue-drag-resize';

export default {
  name: "JitsiMeeting",

  components: {
    Sidebox,
    VueDragResize
  },

  props: {
    domain: {
      type: String,
      required: false,
      default: "8x8.vc",
    },
    options: {
      type: Object,
      required: false,
      default: () => {
        return {
          configOverwrite: {

            // Optimization stuff
            resolution: 360, // 180 360 720
            disableAudioLevels: true,	// Disables the audio levels indication.
            enableLayerSuspension: true,	// Enables the ability to dynamically disable various layers of the video stream.
            desktopSharingFrameRate: { min: 3, max: 10 }, // The minimum and maximum desktop sharing frame rate in frames per second (fps).

            faceLandmarks: {
              enableFaceCentering: false,
              enableFaceExpressionsDetection: false,
              enableDisplayFaceExpressions: false,
              enableRTCStats: false,
              faceCenteringThreshold: 20,
              captureInterval: 10000
            },

            prejoinPageEnabled: false,

            // Controls the visibility and behavior of the top header conference info labels.
            // If a label's id is not in any of the 2 arrays, it will not be visible at all on the header.
            conferenceInfo: {
              // those labels will not be hidden in tandem with the toolbox.
              alwaysVisible: ['raised-hands-count'],
              // those labels will be auto-hidden in tandem with the toolbox buttons.
              autoHide: [
                'subject',
                'conference-timer',
                'participants-count',
                // 'e2ee',
                // 'transcribing',
                'video-quality',
                // 'insecure-room',
                // 'highlight-moment',
                'top-panel-toggle',
              ]
            },

            // Hides the conference subject
            hideConferenceSubject: false,

            // Hides the conference timer.
            hideConferenceTimer: false,

            // Hides the recording label
            hideRecordingLabel: true,

            // Hides the participants stats
            hideParticipantsStats: true,

            // Sets the conference subject
            // subject: 'Conference Subject',

            // Sets the conference local subject
            // localSubject: 'Conference Local Subject',

            toolbarButtons: [
              "camera",
              // "chat",
              "closedcaptions",
              "desktop",
              // "dock-iframe",
              // "download",
              // "embedmeeting",
              // "etherpad",
              // "feedback",
              // "filmstrip",
              // "fullscreen",
              "hangup",
              // "help",
              // "highlight",
              // 'invite',
              // 'linktosalesforce',
              // "livestreaming",
              "microphone",
              // "noisesuppression",
              // "participants-pane",
              // "profile",
              // "raisehand",
              // "recording",
              // "security",
              "select-background",
              "settings",
              // "shareaudio",
              // "sharedvideo",
              // "shortcuts",
              // "stats",
              "tileview",
              "toggle-camera",
              // "undock-iframe",
              // "videoquality",
              // "whiteboard",
            ],
          },
          interfaceConfigOverwrite: {
            APP_NAME: "Jitsi Meet",
            AUDIO_LEVEL_PRIMARY_COLOR: "rgba(255,255,255,0.4)",
            AUDIO_LEVEL_SECONDARY_COLOR: "rgba(255,255,255,0.2)",
            AUTO_PIN_LATEST_SCREEN_SHARE: "remote-only",
            BRAND_WATERMARK_LINK: "",
            CLOSE_PAGE_GUEST_HINT: false,
            DEFAULT_BACKGROUND: "#040404",
            DEFAULT_WELCOME_PAGE_LOGO_URL: "images/watermark.svg",
            DISABLE_DOMINANT_SPEAKER_INDICATOR: false,
            DISABLE_JOIN_LEAVE_NOTIFICATIONS: false,
            DISABLE_PRESENCE_STATUS: false,
            DISABLE_RINGING: false,
            DISABLE_TRANSCRIPTION_SUBTITLES: false,
            DISABLE_VIDEO_BACKGROUND: false,
            DISPLAY_WELCOME_FOOTER: true,
            DISPLAY_WELCOME_PAGE_ADDITIONAL_CARD: false,
            DISPLAY_WELCOME_PAGE_CONTENT: false,
            DISPLAY_WELCOME_PAGE_TOOLBAR_ADDITIONAL_CONTENT: false,
            ENABLE_DIAL_OUT: true,
            ENABLE_FEEDBACK_ANIMATION: false,
            FILM_STRIP_MAX_HEIGHT: 120,
            GENERATE_ROOMNAMES_ON_WELCOME_PAGE: true,
            HIDE_DEEP_LINKING_LOGO: false,
            HIDE_INVITE_MORE_HEADER: false,
            JITSI_WATERMARK_LINK: "https://jitsi.org",
            LANG_DETECTION: true, // Allow i18n to detect the system language
            LOCAL_THUMBNAIL_RATIO: 16 / 9, // 16:9
            MAXIMUM_ZOOMING_COEFFICIENT: 1.3,
            OPTIMAL_BROWSERS: [
              "chrome",
              "chromium",
              "firefox",
              "nwjs",
              "electron",
              "safari",
            ],
            REMOTE_THUMBNAIL_RATIO: 1, // 1:1
            SETTINGS_SECTIONS: [
              "devices",
              "language",
              "moderator",
              "profile",
              "calendar",
              "sounds",
              "more",
            ],
            SHOW_BRAND_WATERMARK: false,
            SHOW_CHROME_EXTENSION_BANNER: false,
            SHOW_DEEP_LINKING_IMAGE: false,
            SHOW_JITSI_WATERMARK: true,
            SHOW_POWERED_BY: false,
            SHOW_PROMOTIONAL_CLOSE_PAGE: false,
            SUPPORT_URL: "https://community.jitsi.org/",
            VERTICAL_FILMSTRIP: true,
            VIDEO_QUALITY_LABEL_DISABLED: false,

            // Determines how the video would fit the screen. 'both' would fit the whole
            // screen, 'height' would fit the original video height to the height of the
            // screen, 'width' would fit the original video width to the width of the
            // screen respecting ratio, 'nocrop' would make the video as large as
            // possible and preserve aspect ratio without cropping.
            VIDEO_LAYOUT_FIT: "both",
          },
        };
      },
    },
    roomID: {
      type: String,
      required: false,
      default: "test",
    },
    roomName: {
      type: String,
      required: false,
      default: "test",
    },
    jwt: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      jitsiAPI: null,
      switched: false,
      chatbox_width: 300,
      chatbox_height: 300,
      showChat: true,
      sideboxHeight: '',
    };
  },
  methods: {
    getJitsiAppID() {
      return new Promise((resolve, reject) => {
        api
          .get(
            `event/${this.$store.state.eventId}/jitsiInfo`
          ).then((response) => {
            // console.log("getAppID response", response.data);
            resolve(response.data[0].appid);
          }).catch((error) => {
            reject(error);
          });
      });
    },
    getJWTAuth() {
      return new Promise((resolve, reject) => {
        api
          .get(
            `event/${this.$store.state.eventId}/jitsiAuthentication`
          ).then((response) => {
            // console.log("getJWTAuth response", response);
            resolve(response.data.token);
          }).catch((error) => {
            reject(error);
          });
      });
    },
    initJitsi(appID, jwt) {
      this.$store.commit('setUserInMeeting', true);
      const domain = this.domain;
      const options = {
        // roomName: `vpaas-magic-cookie-4177ca085c634ddd84a20fed4be0f59b/${this.roomID}`, // Blitzar
        roomName: `${appID}/${this.roomName}`, // Bugfinda
        parentNode: document.getElementById("jaas-container"),
        userInfo: { displayName: this.$store.state.user.name, },
        jwt: jwt,
        lang: "pt",
        ...this.options,
      };

      this.jitsiAPI = new window.JitsiMeetExternalAPI(domain, options);
      this.jitsiAPI.addListener("videoConferenceLeft", this.videoConferenceLeftHandler);

      this.jitsiAPI.addListener("videoConferenceJoined", (data) => {
        this.setTileView();
      });
    },

    hangup() {
      if (this.jitsiAPI) this.jitsiAPI.executeCommand("hangup");
    },

    moderatorEndConference() {
      api.executeCommand('endConference');
    },

    videoConferenceLeftHandler(data) {

      if (this.$store.state.user.inMeeting) {
        // this.freeJitsiSpot();
        this.$emit("videoConferenceLeft", data);
        this.$store.commit('setUserInMeeting', false);
        // console.log("videoConferenceLeftHandler", data);
      }
    },

    setTileView() {
      this.jitsiAPI.executeCommand('setTileView', true);
    },

    switchMode() {
      this.switched = !this.switched;
      // this.$refs.BlitzarMeeting.toggleMode(this.switched);
      this.setTileView();
    },
    freeJitsiSpot() {
      api.post(`event/${this.$store.state.eventId}/jitsiFreeRoom`)
        .then((response) => {
          // console.log("freeJitsiSpot response", response);
        }).catch((error) => {
          console.error("freeJitsiSpot error", error);
        });
    },
    chatboxResizing(newRect) {
      this.$refs.sidebox.resized(newRect);
    }
  },
  beforeMount() {
    this.sideboxHeight = window.innerHeight - 20;
  },
  async mounted() {
    // JITSI
    // jaasScript.src = "https://8x8.vc/vpaas-magic-cookie-4177ca085c634ddd84a20fed4be0f59b"; // Blitzar
    // jaasScript.src = "https://8x8.vc/vpaas-magic-cookie-f25c1ab0b4294ff6b2664a6adb2b78a7/external_api.js"; // Bugfinda

    const jitsiAppID = await this.getJitsiAppID();
    const jaasScript = document.createElement("script");

    jaasScript.src = `https://8x8.vc/${jitsiAppID}/external_api.js`;
    document.head.appendChild(jaasScript);

    const jwt = await this.getJWTAuth();
    setTimeout(() => {
      this.initJitsi(jitsiAppID, jwt);
    }, 1000);
  },
  beforeDestroy() {
    this.freeJitsiSpot();
    this.jitsiAPI.removeListener("videoConferenceLeft", this.videoConferenceLeftHandler);
    this.jitsiAPI.dispose();
  },
};

</script>

<style lang='scss'>
#jaas-container {
  pointer-events: auto;
  width: 100%;
  height: 100%;
  iframe {
    padding: 0;
  }
}

.jitsi-sidebox-container {
  position: relative;
  max-width: 300px;
  pointer-events: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  .jitsi-sidebox-container-icon {
    position: absolute;
    top: 14px;
    right: 6px;
    width: 30px;
    height: 30px;
    z-index: 10;
    cursor: pointer;
    pointer-events: auto;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.jitsi-box {
  position: fixed;
  top: 60px;
  bottom: 0;
  right: 0;
  min-width: 160px;
  background: black;
  z-index: 2;
  padding: 0 0 20px 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;

  display: flex;
  flex-direction: row;
}

.jitsi-mode-switch-btn {
  position: absolute;
  top: 6px;
  left: 6px;
  width: 30px;
  height: 30px;
  z-index: 1;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  cursor: pointer;
  pointer-events: auto;

  display: flex;
  justify-content: center;
  align-items: center;

  @include media("<=tablet") {
    display: none;
  }
}

.jitsi-meeting-chatbox {
  position: fixed;
  top: 120px;
  left: 20px;
  width: auto;
  min-width: 300px;
  pointer-events: auto;
}

.jitsi-meeting-chatbox-drag {
  height: 100%;
  width: 100%;
  min-width: 300px;
  height: 50px;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1000;
  cursor: move;
}
</style>

